export default '/build/ccd2df0c.svg'